// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"29":"css/admin-app.6956","2244":"css/app.6956"}[chunkId] + ".css";
};